import { gsap, ScrollTrigger, ScrollTo } from '../global/gsap';

const initDNA = (dnaEl) => { 
    const navBtnContainer = dnaEl.querySelector('.js-nav');
    const navBtns = gsap.utils.toArray('.js-nav-btn');
    const slides = gsap.utils.toArray('.js-slide');
    let buttonWidth = navBtns[1].offsetWidth;

    const toggleNav = (toHighlight) => {
        navBtns.forEach((btn, i) => {
            btn.classList.toggle('is-active', toHighlight === i);
        });
        navBtnContainer.style.transform = `translateX(-${toHighlight * buttonWidth}px)`;
    };

    const mainST = ScrollTrigger.create({
        trigger: dnaEl,
        start: 'top top',
        end: `+=${(slides.length - 1) * 100}%`,
        pin: true,
        pinSpacing: true
    });

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: dnaEl,
            start: 'top top',
            end: `+=${(slides.length - 1) * 100}%`,
            scrub: true,
            onUpdate: (self) => {
                // const i = Math.round(self.progress * (slides.length - 1));
                // navBtns.forEach(btn => btn.classList.remove('is-active'));
                // if(navBtns[i]) navBtns[i].classList.add('is-active');

                const segment = 1 / (slides.length - 1);
                const progress = self.progress;
                const offset = self.direction === 1 ? 0.1 : -0.1;
                let activeIndex = Math.floor((progress + offset) / segment);
                activeIndex = Math.max(0, Math.min(activeIndex, slides.length - 1));
                toggleNav(activeIndex);
            }
        }
    });

    slides.forEach((slide, i) => {
        gsap.set(slide, { zIndex: slides.length - i });

        if (i < slides.length - 1) {
            tl.to(slide, {
                yPercent: -100,
                ease: 'none'
            }, i === 0 ? 0 : '>');
        }
    });

    navBtns.forEach((btn, i) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            const scrollDistance = mainST.end - mainST.start;
            const targetScroll = mainST.start + (i / (slides.length - 1)) * scrollDistance;

            gsap.to(window, {
                duration: 1,
                scrollTo: targetScroll,
                ease: 'power3.inOut'
            });
        });
    });

    // Re-get the size of the buttons on window resize
    window.addEventListener('resize', () => {
        const buttonToMeasure = dnaEl.querySelector('.js-nav-btn:not(.is-active)');
        buttonWidth = buttonToMeasure.offsetWidth;
    });
};

export { initDNA as default };
